<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword"
                        :placeholder="$t('keyword')" v-on:keydown.enter="load"></b-form-input>
          <form-select class="mr-1 mb-1" :model="filterFormModel" attribute="type"
                       :options="actionOpts"></form-select>
          <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-lg-2">{{ $t('time') }}</div>
          <div class="col-lg-8">{{ $t('content') }}</div>
          <div class="col-lg-2">{{ $t('createdBy') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-2">
            <span>{{ item.time | moment('DD/MM/YYYY HH:mm:ss') }}</span>
          </div>
          <div class="col-lg-8">
            <div class="c-sms-item__title" style="width: 75%">
              <span class="text-gray-999">
                {{ $t(getOppLogLabel(item)) }}:
              </span>
              <b>
                {{ item.opportunity ? item.opportunity.name : $t('unknown') }}
              </b>&nbsp;
              <span class="c-sms-item__label" v-if="item && item.type === 'change'">
                      <span class="badge badge-primary is-label" style="min-width: 70px">{{ item.fromStatus }}</span>
                      &nbsp;<i class="fa fa-long-arrow-right"></i>&nbsp;
                      <span class="badge badge-primary is-label" style="min-width: 70px">{{ item.toStatus }}</span>
              </span>
            </div>
          </div>
          <div class="col-lg-2">
            <span v-if="item.user">{{ item.user.name }} ({{ item.user.ext }})</span>
            <span v-else>{{ $t('unknown') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from "@/mixins/List";
import TimeRangePicker from "@/components/TimeRangePicker.vue";

export default {
  components: {TimeRangePicker},
  props: ['client'],
  mixins: [List],
  data() {
    return {
      service: 'opportunity-log',
      autoLoad: true,
      defaultFilterFormModel: {
        type: null,
        client: this.client._id,
      },
      actionOpts: [
        {value: null, text: this.$t('chooseAction')},
        {value: 'create', text: this.$t('create')},
        {value: 'update', text: this.$t('update')},
        {value: 'cancel', text: this.$t('cancel')},
        {value: 'change', text: this.$t('updateStatus')},
      ],
    }
  },
  methods: {
    getOppLogLabel(item) {
      if (item) {
        if (item.type === 'create') {
          return 'createOpp'
        }
        if (item.type === 'update') {
          return 'updateOpp'
        }
        if (item.type === 'cancel') {
          return 'cancelOpp'
        }
        if (item.type === 'change') {
          return 'changeStatusOpp'
        }
      }
      return null;
    },
  },
  i18n: {
    messages: {
      en: {
        createOpp: "Create new sales opportunities",
        updateOpp: "Update sales opportunities",
        cancelOpp: "Cancel sales opportunity",
        changeStatusOpp: "Update sales opportunity status",
        content: "Content",
        createdBy: "Created by",
        status: "Status",
        updateStatus: "Update status",
        chooseAction: "Choose action  ",
      },
      vi: {
        createOpp: "Tạo mới cơ hội bán hàng",
        updateOpp: "Cập nhật cơ hội bán hàng",
        cancelOpp: "Huỷ cơ hội bán hàng",
        changeStatusOpp: "Cập nhật trạng thái cơ hội bán hàng",
        content: "Nội dung",
        createdBy: "Tạo bởi",
        status: "Tình trạng",
        updateStatus: "Cập nhật trạng thái",
        chooseAction: "Chọn hành động",
      }
    }
  },
}
</script>